/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * Machine-readable error code returned in the body of a coded error response. Clients branch on this value, never on the bare HTTP status.
 */
export enum DataModelErrorCode {
    RANGE_NAMES_ALREADY_EXIST = 'range_names_already_exist',
    RANGE_NAMES_DUPLICATED = 'range_names_duplicated',
}
